import IntakeConfig from '../../interfaces/IntakeConfig.interface';

const validateConfig = (config: IntakeConfig) => {
  if (config.reps && !config.reps.every(r => r.franchiseCode)) throw new Error('Missing required rep.franchiseCode');
};

export default validateConfig;
